<template>
  <div class="qualification_reclaim_toast">
    <ns-toast-vue
      custom
      theme="success"
      type="fleeting"
      toast-event-name="qualificationReclaimed"
      duration="5000"
    >
      <template v-slot:custom>
        <div class="reclaim_message">
          <ns-icon icon-name="icon-exclusive-offer" />
          <span>{{tdc.tdc_reclaimToastSuccess}}</span>
        </div>
      </template>
    </ns-toast-vue>
  </div>
</template>

<script>
import { NsIcon } from '@nuskin/ns-icon'
import config from '../../js/qualificationsConfigService'

export default {
  components: {
    NsIcon,
  },
  data() {
    return {
    }
  },
  computed: {
    tdc() {
      return config.getTdc()
    },
  },
  mounted() {
  },
  methods: {},
}
</script>

<style>
@media (min-width: 1024px) {
  .qualification_reclaim_toast .custom {
    display: flex;
    align-items: center;
  }

  .qualification_reclaim_toast .reclaim_message {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    margin: 0 auto;
  }

  .qualification_reclaim_toast .transfer_message .icon {
    height: 30px;
    width: 70px;
  }
}
</style>
